import React from "react";

import NewsletterImage from "../../assets/images/Newsletter2.png";
function Newsletter() {
  const handleWhatsAppClick = () => {
    window.open("https://wa.me/+96565111161", "_blank");
  };

  return (
    <div>
      <div className="row d-flex  align-items-center">
        <div className=" col-lg-6 col-md-12 col-sm-12 col-xs-12 shadow-sm  bg-white rounded-4  p-5">
          <h2 className="text-right   py-3 lh-base">
            اشترك في مجموعة
            <span
              style={{
                color: "#25D366",
                fontWeight: "bold",
                fontSize: "2rem",
                padding: "0 0.5rem",
              }}
            >
              WhatsApp{" "}
            </span>{" "}
          </h2>
          <div className=" d-flex">
            <button
              type="submit"
              className="btn btn-outline-success mx-2 "
              // onClick={handleWhatsAppClick}
            >
              اشترك الان <i className="fab fa-whatsapp"></i>
            </button>
          </div>
        </div>

        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center align-items-center">
          <img
            src={NewsletterImage}
            alt="Maged Bannar"
            className="img-fluid"
            style={{ borderRadius: "10px", width: "300px" }}
          />
        </div>
      </div>
    </div>
  );
}

export default Newsletter;
